export default __webpack_public_path__ + "static/media/team_etm.cc666058.png";